import { useGetPageConfigQuery } from 'store/slices/cdn-api';

const usePageConfig = () => {
  const { data: pageConfig } = useGetPageConfigQuery();
  return pageConfig;
};

export default usePageConfig;
